import React from "react";
import "./CatchDisposition.scss";
import { useSelector } from "react-redux";
import { Box, List, ListItemText, ListItem, TextField } from "@mui/material";
import HelpText, { getHelpText } from "../HelpText/HelpText";

const CatchDisposition = (props) => {
  const speciesList =
    useSelector((state) => state.validation.validations.species) || [];
  let speciesDescription = "";
  speciesList
    .filter((item) => item.SPPCODE === props.species)
    .map((item) => (speciesDescription = item.SPPNAME));

  return (
    <div
      className="CatchDisposition"
      data-testid="CatchDisposition"
      style={{ width: "100%" }}
    >
      <h2 className="sectionTitle center">Species Catch</h2>
      <Box mt={0} display="flex" flexDirection="column" alignItems="center">
        <List>
          <ListItem>
            <ListItemText>
              {`Species Code: ${props.species}`}
              <br />
              {`Species Name: ${speciesDescription}`}
              <br />
              {`Qty. Available: ${props.salesAvailable}`}
              <br />
            </ListItemText>
          </ListItem>
        </List>
        <Box display="flex" justifyContent="center">
          <Box flexGrow={1}>
            <TextField
              variant="standard"
              label="Sold:"
              className="number-of-input"
              inputProps={{
                min: 0,
                max: Number(props.originalAvailable),
                style: { textAlign: "center", minWidth: "250px" },
              }}
              name={"sold"}
              type="number"
              value={props.sold}
              onChange={(e) => props.handleCatchDispositionChange(e, props)}
              helperText={getHelpText(props.helpText, "sales_quantity")}
            />
          </Box>
          <Box>
            <HelpText
              helpText={getHelpText(props.helpText, "sales_quantity")}
            />
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default CatchDisposition;
